'use client';

import React from 'react';
import { motion } from 'framer-motion';

// Konfigurasi animasi tetap dipertahankan agar transisi halus
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function SectionClean() {
  return (
    <section className="relative py-12 px-4 md:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        {/* Container Grid Utama */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
        >
          {/* Bagian isi (Layanan & Highlights) sudah dibersihkan. 
              Anda bisa memasukkan konten baru di bawah ini menggunakan:
              <motion.div variants={cardVariants}> ... </motion.div>
          */}
        </motion.div>
      </div>
    </section>
  );
}